import { HelpDocumentEdit } from 'src/app/help-document/model/help-document-edit';
import { HelpDocumentList } from 'src/app/help-document/model/help-document-list';
import { CacheBuster } from 'ts-cacheable';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

const helpDocumentCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class HelpDocumentService
{

  constructor(private http: HttpClient) { }

  /**
   * Save a Help Document.
   *
   * @param data Help Document to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: helpDocumentCacheBuster
    })
  public saveHelpDocument(data: any, isNew: boolean, helpDocumentId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/help/document', data);
    }
    else
    {
      return this.http.put(`/help/document/${helpDocumentId}`, data);
    }
  }

  /**
   * Delete a Help document.
   *
   * @param id Help Document id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: helpDocumentCacheBuster
    })
  public deleteHelpDocument(id: number): Observable<HelpDocumentList>
  {
    return this.http.delete<HelpDocumentList>(`/help/document/${id}`);
  }

  /**
   * Get Help Document for grid list.
   */
  public getHelpDocumentList(enabledOnly = false): Observable<HelpDocumentList[]>
  {
    return this.http.get<HelpDocumentList[]>(`/help/document/list?enabledOnly=${enabledOnly}`);
  }

  /**
   * Get Help Document by id.
   *
   * @param id Help Document id
   */
  public getHelpDocumentById(id: number): Observable<HelpDocumentEdit>
  {
    return this.http.get<HelpDocumentEdit>(`/help/document/${id}`);
  }

  /**
   * Get Help Document by id.
   *
   * @param id Help Document id
   */
  public getHelpDocumentImportById(id: number): Observable<HelpDocumentEdit>
  {
    return this.http.get<HelpDocumentEdit>(`/help/document/import/${id}`);
  }

  /**
   * Check if Help Document is in use
   *
   * @param id Help Document Id
   */
  public existsHelpDocument(id: number): Observable<any>
  {
    return this.http.get(`/help/document/inuse/${id}`);
  }

  /**
   * Check if Help Documenmt is in use (enabled?) Do we need to check if document is "enabled" before delete request?
   *
   * @param name Help Document name
   */
  public existsHelpDocumentName(name: string): Observable<any>
  {
    return this.http.get(`/help/document/exists?name=${name}`);
  }
}

